export default "__VITE_ASSET__d65695e4__"